import React, { ReactNode, ReactElement } from "react";

type ProviderComponent = (props: { children: ReactNode }) => ReactElement | null;

export function composeProviders(providers: ProviderComponent[]): ProviderComponent {
  return function ComposedProvider({ children }: { children: ReactNode }): ReactElement {
    return providers.reduceRight<ReactNode>(
      (acc, Provider) => <Provider>{acc}</Provider>,
      children
    ) as ReactElement; // cast ensures TS treats it as ReactElement
  };
}